import { render, staticRenderFns } from "./BrigadeMap.vue?vue&type=template&id=8f9016ae&"
import script from "./BrigadeMap.vue?vue&type=script&lang=js&"
export * from "./BrigadeMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtn,QTooltip,QTabs,QTab,QBadge,QIcon,QItem,QSpace,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QBtn,QTooltip,QTabs,QTab,QBadge,QIcon,QItem,QSpace,QInnerLoading,QSpinnerGears}, component.options.components || {})
